import { INavigationRoute } from 'transfix-ui/components/NavigationBar/types'
import { filterRoutes } from 'transfix-ui/components/NavigationBar/utils/filterRoutes'
import {
  getDefaultRouteUserOptions,
  IGenerateDefaultRoutesOptions,
} from 'transfix-ui/components/NavigationBar/utils/getDefaultRouteUserOptions'

export const getToolsMenuRoutes = (
  options: IGenerateDefaultRoutesOptions = getDefaultRouteUserOptions()
): INavigationRoute[] => {
  const { authToken, isAdmin } = options || {}
  if (!authToken) {
    return []
  }

  return [
    {
      name: 'Rate & Pricing Tools',
      location: '',
      childRoutes: filterRoutes([
        { name: 'Cost Control', location: 'spot-control-panel', display: isAdmin },
        { name: 'Spot Control', location: 'spot-control-panel', display: isAdmin },
        { name: 'Spot Quote Tool', location: 'spot-quote-tool', display: isAdmin },
        { name: 'Instant RFP', location: 'instant-rfp', display: isAdmin },
        { name: 'Shipper Rate Matcher', location: 'shipper-rate-matcher', display: isAdmin },
      ]),
    },
    {
      name: 'Operations Tools',
      location: '',
      childRoutes: filterRoutes([
        { name: 'Carrier Options', location: 'carrier-options', display: isAdmin },
        { name: 'Issue Control Panel', location: 'issues/control-panel', display: isAdmin },
      ]),
    },
    {
      name: 'Finance Tools',
      location: '',
      childRoutes: filterRoutes([
        { name: 'Accounting Tools', location: 'accounting-tools', display: isAdmin },
      ]),
    },
  ]
}
